import React, { useEffect } from 'react';
import { Row, Col, Form, Select, Button, Input, DatePicker, InputNumber } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { gethistory, addhistory, updateHistory, } from 'store/auth/profile/profileSlice';
import moment from 'moment';

const { RangePicker } = DatePicker;

export const HistoryForm = ({ setShowModal, editMode = false, initialData = null }) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.Profile.profile);
  const [form] = Form.useForm();

  useEffect(() => {
    if (editMode && initialData) {
      // Format the dates for the DatePicker
      const startDate = initialData.dateRange?.startDate ? initialData.dateRange.startDate.slice(0, 4) : null;
      const endDate = initialData.dateRange?.endDate ? initialData.dateRange.endDate.slice(0, 4) : null;

      form.setFieldsValue({
        clubName: initialData.clubName,
        position: initialData.position, // Changed from 'role' to match your history display
        category: initialData.category,
        // Set the date range if available
        period: startDate && endDate ? [
          startDate ? moment(startDate) : null,
          endDate ? moment(endDate) : null,
        ] : null,
        matchesPlayed: initialData.matchesPlayed,
        goalsScored: initialData.goalsScored,
        assists: initialData.assists,
      });
    }
  }, [form, initialData, editMode]);

  const onFinish = async (values) => {
    // Format the data for submission
    const formData = {
      clubName: values.clubName,
      position: values.position, // Changed from 'role' to match your history display
      category: values.category,
      dateRange: {
        startDate: values.period[0].format('YYYY-MM-DD'),
        endDate: values.period[1].format('YYYY-MM-DD'),
      },
      matchesPlayed: values.matchesPlayed || 0,
      goalsScored: values.goalsScored || 0,
      assists: values.assists || 0,
    };

    try {
      if (editMode && initialData) {
        // Update existing history entry
        await dispatch(updateHistory({ id: initialData._id, data: formData }));
      } else {
        // Add new history entry
        await dispatch(addhistory({ formData: formData, id: profile._id }));
      }
      // Refresh history data
      dispatch(gethistory(profile?._id));
      setShowModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <div className="d-flex justify-content-center p-3">
        <h4>{editMode ? "Modifier" : "Ajouter"} une expérience professionnelle ou sportive</h4>
      </div>
      <Row gutter={16}>
        <Col span={12} xs={24} sm={12} md={12} lg={12}>
          {/* Nom de l'équipe ou du club */}
          <Form.Item name="clubName" label="Nom de l'équipe ou du club" rules={[{ required: true, message: "Veuillez entrer un nom" }]}>
            <Input placeholder="Ex: FC Barcelone" />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} sm={12} md={12} lg={12}>
          {/* Poste ou rôle */}
          <Form.Item name="position" label="Poste ou rôle" rules={[{ required: true, message: "Veuillez entrer un poste" }]}>
            <Input placeholder="Ex: Attaquant, Milieu de terrain, Coach" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12} xs={24} sm={12} md={12} lg={12}>
          {/* Catégorie */}
          <Form.Item name="category" label="Catégorie" rules={[{ required: true, message: "Veuillez sélectionner une catégorie" }]}>
            <Select placeholder="Choisir une catégorie">
              <Select.Option value="U6-U7">U6-U7</Select.Option>
              <Select.Option value="U8-U9">U8-U9</Select.Option>
              <Select.Option value="U10-U11">U10-U11</Select.Option>
              <Select.Option value="U12-U13">U12-U13</Select.Option>
              <Select.Option value="U14-U15">U14-U15</Select.Option>
              <Select.Option value="U16-U17">U16-U17</Select.Option>
              <Select.Option value="U18-U19">U18-U19</Select.Option>
              <Select.Option value="Senior">Senior</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12} xs={24} sm={12} md={12} lg={12}>
          {/* Période */}
          <Form.Item name="period" label="Période" rules={[{ required: true, message: "Veuillez sélectionner la période" }]}>
            <RangePicker picker="year" style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      {/* Statistiques */}
      <Row gutter={16}>
        <Col span={8} xs={24} sm={8} md={8} lg={8}>
          <Form.Item name="matchesPlayed" label="Matchs joués" rules={[{ required: true, message: "Entrez le nombre de matchs" }]}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={8} md={8} lg={8}>
          <Form.Item name="goalsScored" label="Buts marqués" rules={[{ required: true, message: "Entrez le nombre de buts" }]}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={8} md={8} lg={8}>
          <Form.Item name="assists" label="Passes décisives" rules={[{ required: true, message: "Entrez le nombre de passes" }]}>
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end" style={{ marginTop: '20px' }}>
        <Col>
          <Button type="default" onClick={() => setShowModal(false)} style={{ marginRight: '10px' }}>
            Annuler
          </Button>
          <Button type="primary" htmlType="submit">
            {editMode ? "Mettre à jour" : "Ajouter"}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};